import React, { useState, useEffect } from 'react';
import { Form, Input, InputNumber, Select, Switch, Button, message, Spin } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { categoryApi, photoTypeApi } from '../../services/api';

const AdminCategoryForm = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const params = useParams();
  const { companySlug } = params;
  const id = params.id;
  const isEdit = !!id;

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [photoTypeOptions, setPhotoTypeOptions] = useState([]);

  useEffect(() => {
    const loadPhotoTypes = async () => {
      try {
        const res = await photoTypeApi.all();
        const allTypes = (res.data || []).filter(pt => pt.status !== 0);
        // 按level分组，先batch后product
        allTypes.sort((a, b) => {
          if (a.level !== b.level) return a.level === 'batch' ? -1 : 1;
          return (a.sort_order || 0) - (b.sort_order || 0);
        });
        const options = allTypes.map(pt => ({
          label: `${pt.name}${pt.level === 'product' ? '（货品级）' : '（批次级）'}`,
          value: String(pt.id),
        }));
        setPhotoTypeOptions(options);
      } catch {}
    };
    loadPhotoTypes();
  }, []);

  useEffect(() => {
    if (isEdit) {
      const loadData = async () => {
        setLoading(true);
        try {
          const res = await categoryApi.detail(id);
          const cat = res.data;
          form.setFieldsValue({
            name: cat.name,
            photoTypes: cat.photo_types ? cat.photo_types.split(',') : [],
            sortOrder: cat.sort_order,
            status: cat.status === 1,
          });
        } catch {
          message.error('加载品类失败');
        } finally {
          setLoading(false);
        }
      };
      loadData();
    } else {
      form.setFieldsValue({ sortOrder: 0, status: true });
    }
  }, [id]);

  const onFinish = async (values) => {
    setSaving(true);
    try {
      const data = {
        name: values.name,
        photoTypes: (values.photoTypes || []).join(','),
        sortOrder: values.sortOrder || 0,
        status: values.status ? 1 : 0,
      };
      if (isEdit) {
        await categoryApi.update(id, data);
        message.success('更新成功');
      } else {
        await categoryApi.create(data);
        message.success('创建成功');
      }
      navigate(`/${companySlug}/admin/categories`);
    } catch (err) {
      message.error(err.response?.data?.message || '保存失败');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <Spin />;

  return (
    <div>
      <h2>{isEdit ? '编辑品类' : '新增品类'}</h2>
      <Form form={form} layout="vertical" onFinish={onFinish} style={{ maxWidth: 600 }}>
        <Form.Item name="name" label="品类名称" rules={[{ required: true, message: '请输入品类名称' }]}>
          <Input placeholder="如：手镯" maxLength={50} />
        </Form.Item>
        <Form.Item name="photoTypes" label="关联照片类型" extra="选择该品类下需要上传的照片类型（含批次级和货品级）">
          <Select mode="multiple" placeholder="选择照片类型" options={photoTypeOptions} />
        </Form.Item>
        <Form.Item name="sortOrder" label="排序">
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="status" label="启用" valuePropName="checked">
          <Switch checkedChildren="启用" unCheckedChildren="禁用" defaultChecked />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={saving}>保存</Button>
          <Button style={{ marginLeft: 8 }} onClick={() => navigate(`/${companySlug}/admin/categories`)}>取消</Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AdminCategoryForm;
